import { useState, useContext } from "react";
import { StateContextType } from "../../../types/state.types";
import "../../../assets/css/order-confirmation.css";
import MainStateContext from "../../../state/mainStateContext";
import OrderConfirmationComplete from "./OrderConfirmationComplete";
import OrderConfirmationStart from "./OrderConfirmationStart";
import OrderConfirmationBoothComplete from "./OrderConfirmationBoothComplete";
import { WhatsNextAndFooter } from "../../Shared/WhatsNextAndFooter";
import AfterEventSignUpMessage from "./AfterEventSignUpMessage";
import { isAfterDatetime } from "../../../helpers";
import { Say } from "../../../languages";
import AlertMessage from "../../Shared/AlertMessage";

const OrderConfirmationWrapper = () => {
  const { state } = useContext(MainStateContext) as StateContextType;
  const { currentOrder } = state;

  if (!currentOrder) {
    return (
      <div className="order-confirmation__wrapper">
        <AlertMessage alertType="info">
          <Say phrase="chosen.thank_you.order_details_unavailable" />
        </AlertMessage>
      </div>
    );
  }

  const { photo, orderId, email, signUpEndDate } = currentOrder;
  const [boothComplete, toggleBoothComplete] = useState(false);
  const isAfterEventDate = isAfterDatetime(signUpEndDate);

  return (
    <div className="order-confirmation__wrapper">
      <OrderConfirmationComplete
        visible={!!photo}
        photo={photo}
        orderId={orderId}
        emailAddress={email}
      />
      <OrderConfirmationStart
        visible={!boothComplete && !photo && !isAfterEventDate}
        currentOrder={currentOrder}
        toggleBoothComplete={toggleBoothComplete}
      />
      <OrderConfirmationBoothComplete
        visible={boothComplete}
        emailAddress={email}
        orderId={orderId}
        toggleBoothComplete={toggleBoothComplete}
      />
      <AfterEventSignUpMessage visible={isAfterEventDate} />
      <WhatsNextAndFooter visible={!!photo || boothComplete} />
    </div>
  );
};

export default OrderConfirmationWrapper;
